import axios from './axios'
import qs from 'qs';
let userBastUrl = '/resource/';
let featureBaseUrl = "/api/roleAuthority/";
/**
 *
 *
 */
export default {
  getResourceList(data) {
    return axios.get(userBastUrl + 'list', {
      params: data
    });
  },
  getAllResource(data) {
    return axios.get(userBastUrl + 'allResourceList', {
      params: data
    });
  },
  addOrEditResource(data) {
    return axios.post(userBastUrl + 'addOrEditResource', qs.stringify(data));
  },
  getRoleTreeMap(data) {
    return axios.get(featureBaseUrl + 'getRoleTreeMap', {
      params: data
    });
  },
  getPageAuthorityList(data) {
    return axios.get(featureBaseUrl + 'getPageAuthorityList', {
      params: data
    });
  },
  getRoleAuthorityList(data) {
    return axios.get(featureBaseUrl + 'list', {
      params: data
    });
  },
  editRoleAuthority(data) {
    return axios.post(featureBaseUrl + 'addOrEditRoleAuthority', qs.stringify(data));
  },

  getAuthorityList(data) {
    return axios.get(featureBaseUrl + 'authorityList', {
      params: data
    });
  },

  editAuthority(data) {
    return axios.post(featureBaseUrl + 'addOrEditAuthority', qs.stringify(data));
  },

}
